export const baseHusky = 'https://master.mirbackend.huskyjam.com'
export const base = 'https://mir.championat.com'